/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { getUpdate, postCreate, PutUpdate } from "../../../components/Data";

import Axios from "axios";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import DashboardContext from "../../../Context";
import Loader from "../../layout/Loader";
import SearchFrom from "../SearchFrom";
import Tabelrowbody from "./Tabelrowbody";
import InputClock from "../../inputs/InputClock";
import ModalConfirmCancelJobDispatch from "../ModalConfirmCancelJobDispatch";

import "../tabel.css";
import ExcelExport from "../ExcelExport";
import { toast } from "react-toastify";
import ModalPrint from "./ModalPrint";
import InputPricing from "../../../components/inputs/InputPricing";
import NumberFormat from "react-number-format";
import InputMask from "react-input-mask";
import Countdown from 'react-countdown';

/**
 * این کامپوننت برای نمایش جدول در بخش نیرو است که لینک اسم نیرو به پروفایل نیرو را دارد
 */
export default function TableJobDispatchWorker({
  isFromProfile,
  urldata,
  arryactions,
  isform,
  showform,
  handelShowForm,
  FormTabel,
  itemname,
  params,
  page,
  pageSiz,
  hiddenitem,
  tipLink,
  reload,
  data,
  setLoadingOff
}) {
  const {
    sideBardata,
    authentication,
    urldashboard,
    idview,
    accessPage,
    handelloding,
    dataFromTabel,
    handelerrors,
    searchLoading,
    setOffSearchLoding
  } = useContext(DashboardContext);

  const [dataFech, setDataFech] = useState([]);


  const [startpage, setStartpage] = useState(
    page ? page : JSON.parse(sessionStorage.getItem("startpage")) || 1
  );

  const [pageSize, setPageSize] = useState(
    pageSiz ? pageSiz : JSON.parse(sessionStorage.getItem("pageSize")) || 10
  );

  const [serch, setSerch] = useState(
    JSON.parse(sessionStorage.getItem("serch")) || ""
  );

  const [deleteitem, setDeleteitem] = useState(false);
  const [loader, setLoader] = useState(true);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [inputvalue, setInputvalue] = useState("");
  const [showConfirmCancelModal, setShowConfirmCancelModal] = useState(false);
  const [worker, setWorker] = useState({});

  const [cancelWithPenalty, setCancelWithPenalty] = useState(false);

  const datafeching = async (startpage, pageSize, serch) => {

    let formdata = {};

    if (isform) {
      formdata = {
        page: parseInt(startpage),
        pageSize: parseInt(pageSize),
        isFromProfile: isFromProfile,
        search: serch,
        ...dataFromTabel,
        [itemname]: params
          ? params
          : JSON.parse(sessionStorage.getItem("customerid"))
            ? JSON.parse(sessionStorage.getItem("customerid"))
            : idview,
      };
    } else {
      formdata = {
        page: parseInt(startpage),
        pageSize: parseInt(pageSize),
        search: serch,
        isFromProfile: isFromProfile,
        ...dataFromTabel,
      };
    }

    try {

      var url = `${urldashboard}${urldata}`;

      const res = await Axios.post(url,
        JSON.stringify(formdata),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.data;

      setDataFech(data.data);
      setLoadingOff();
      //setOffSearchLoding();
      setLoader(false);
      handelloding(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  const cancelJobDispatch = async (id) => {

    try {

      const res = await Axios.get(
        `${urldashboard}/jobdispatch/cancel/${id}`,
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );

      const data = await res.data;
      //handelLoadingform(false)
      toast.success(data.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      datafeching(startpage, pageSize, serch);
      setCancelWithPenalty(false);
      setShowConfirmCancelModal(false);
      setTimeout(() => {
        datafeching(startpage, pageSize, serch);
      }, 60500);

    } catch (error) {
      handelerrors(error);
    }
  };

  const cancelWithPenaltyJobDispatch = async (id) => {

    try {

      const res = await Axios.get(
        `${urldashboard}/jobdispatch/cancelWithPenalty/${id}`,
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );

      const data = await res.data;
      //handelLoadingform(false)
      toast.success(data.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      datafeching(startpage, pageSize, serch);
      setCancelWithPenalty(false);
      setShowConfirmCancelModal(false);
      setTimeout(() => {
        datafeching(startpage, pageSize, serch);
      }, 60500);

    } catch (error) {
      handelerrors(error);
    }
  };


  useEffect(() => {
    datafeching(startpage, pageSize, serch);
  }, [
    startpage,
    pageSize,
    serch,
    deleteitem,
    dataFromTabel,
    reload,
    searchLoading,
    refreshGrid,
  ]);

  //logic serch start
  const handelserchinput = (e) => {
    if (e.target.value) {
      setInputvalue(e.target.value);
    } else {
      setInputvalue("");
      sessionStorage.setItem("serch", JSON.stringify(""));
      setSerch("");
      sessionStorage.setItem("startpage", JSON.stringify(1));
      sessionStorage.setItem("Pagination", JSON.stringify([]));
      setStartpage(1);
    }
  };

  const getRowColor = (item) => {

    if (item.isFirstLayer)
      return 'rgb(222 189 255)';
    if (item.status === 5)
      return '#7dff7d';

    return 'white';
  }

  return (
    <>
      {sideBardata.length > 0 ? (
        <>
          {!loader ? (
            dataFech.length > 0 ? (
              <>
                <div className="table-responsive ">
                  <Table hover bordered>
                    <thead>
                      <tr style={{ backgroundColor: '#ffe4e4' }}>
                        <th style={{ width: 20, textAlign: "center" }}>ردیف</th>
                        <th style={{ textAlign: "center" }}>نام نیرو</th>
                        <th style={{ textAlign: "center" }}>شماره موبایل</th>
                        <th style={{ textAlign: "center" }}>اپلیکیشن</th>
                        <th style={{ textAlign: "center" }}>وضعیت</th>
                        <th style={{ width: 300, textAlign: "center" }}>زمان باقی مانده برای پاسخ</th>
                        <th style={{ width: 300, textAlign: "center" }}>زمان آخرین اقدام</th>
                        <td style={{ width: 20, textAlign: "center" }}>لغو</td>
                        <td style={{ width: 250, textAlign: "center" }}>لغو با جریمه و امتیاز منفی</td>
                      </tr>
                    </thead>
                    <tbody>
                      {dataFech.map((item, index) => {
                        return (
                          <>
                            <tr style={{ backgroundColor: getRowColor(item) }}>

                              <td style={{ width: 20, textAlign: "center" }}>{++index}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.fullName}
                              </td>

                              <td style={{ textAlign: "center" }}>
                                {item.cellPhone}
                              </td>

                              <td style={{ textAlign: "center" }}>
                                {item.hasApp ? <i style={{ color: 'green' }} class="fa fa-check" aria-hidden="true"></i> : <i style={{ color: 'red' }} class="fa fa-times" aria-hidden="true"></i>}
                              </td>

                              <td style={{ textAlign: "center" }}>
                                {item.workerJobDispatchStatus}
                              </td>

                              <td style={{ textAlign: "center" }}>
                                {item.status === 0 ? <Countdown date={item.responseDeadLine + 10000} /> : <i>----</i>}
                              </td>

                              <td style={{ textAlign: "center" }}>
                                {item.persianActionTime}
                              </td>

                              <td style={{ width: 20, textAlign: "center" }}>
                                {arryactions ? (
                                  arryactions.includes("Cancel") && (item.status === 0 ||
                                    item.status === 5 ||

                                    item.status === 1) ? (

                                    <button className="btn btn-warning" onClick={() => {
                                      setShowConfirmCancelModal(true)
                                      setWorker({ id: item.id, workerName: item.fullName })
                                    }

                                    }>
                                      لغو
                                    </button>

                                  ) : null
                                ) : accessPage.includes("Cancel") ? (
                                  <i className="mdi icon-sm mdi-delete"></i>
                                ) : null}
                              </td>

                              <td style={{ textAlign: "center" }}>
                                {arryactions ? (
                                  arryactions.includes("Cancel") && (item.status === 0 ||
                                    item.status === 5 ||

                                    item.status === 1) ? (

                                    <button className="btn btn-danger" onClick={() => {
                                      setShowConfirmCancelModal(true)
                                      setCancelWithPenalty(true)
                                      setWorker({ id: item.id, workerName: item.fullName })
                                    }
                                    }>
                                      لغو با جریمه و امتیاز منفی
                                    </button>

                                  ) : null
                                ) : accessPage.includes("CancelWithPenalty") ? (
                                  <i className="mdi icon-sm mdi-delete"></i>
                                ) : null}
                              </td>

                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </Table>

                  <ModalConfirmCancelJobDispatch
                    isShow={showConfirmCancelModal}
                    submit={() => cancelWithPenalty ? cancelWithPenaltyJobDispatch(
                      worker.id
                    ) : cancelJobDispatch(worker.id)}
                    cancelWithPenalty={cancelWithPenalty}
                    workerName={worker.workerName}
                    handleCloseModal={() => { setShowConfirmCancelModal(false); setCancelWithPenalty(false) }}
                  />

                </div>
              </>
            ) : (
              <div style={{ textAlign: 'center' }}>چیزی یافت نشد :(</div>
            )
          ) : (
            <Loader />
          )}
        </>
      ) : (
        <Loader />
      )}
    </>
  );
}
